import _ from 'lodash';
import { makeAutoObservable } from 'mobx';
import GlobalNotification from '../../component/common/snackbar';
import { CommonDialog } from '../../component/dialog/commonDialog';
import { Group, Staff } from '../../models';
import apiManage from '../../request';
import i18n from 'i18next';
// 对应账号管理的请求 belonged 的query参数
enum Belonged {
    'no_bundle' = '0',
    'bundle' = '1',
    'all' = '2',
    'none' = '3'
}

export class GroupUnitData {

    constructor(group?: Group) {
        if (group) {
            this.belongedGroup = group.string_id!;
            this.belongedGroupId = group._id!;
            this.belongedGroupName = group.nickname!;
        }
        makeAutoObservable(this)
    }

    // ******************
    // property
    // ******************

    // 集团stringId
    belongedGroup: string = '';
    // 集团Id
    belongedGroupId: string = '';
    // 集团名称
    belongedGroupName: string = '';
    // 集团绑定的经销商
    belongedReseller: string = '';

    rowsPerPage: number = 999;
    pageIndex: number = 1
    staffs: Staff[] = [];

    // 0 不绑定  1 绑定 2 全部
    belonged: Belonged = Belonged.all;
    isTableLoading: boolean = false;

    /**
     *  0  { title: "集团账号" },
     *  1    { title: "餐厅管理" },
     *  2    { title: "账号管理" },
     *  3    { title: "授权管理" },
     */
    panel = 0;

    route: number = 0;

    dialog: CommonDialog = { open: false }
    // ******************
    // function
    // ******************

    updateBelonged(arr: boolean[], i: number) {
        let temp = _.cloneDeep(this.belonged);
        if (arr[0] && arr[1]) {
            temp = Belonged.all;
        } else if (!arr[0] && !arr[1]) {
            if (i === 0) {
                temp = Belonged.no_bundle;
            } else {
                temp = Belonged.bundle;
            }
        } else if (arr[0] && !arr[1]) {
            temp = Belonged.bundle;
        } else if (!arr[0] && arr[1]) {
            temp = Belonged.no_bundle;
        }
        this.belonged = temp;
        this.getStaffsData();
    }

    updatePanel(value: number) {
        this.panel = value;
    }
    updateRoute() {
        this.route = 0
    }

    // 选中的集团_id
    updateGroupId(group: Group) {
        this.belongedGroupId = group._id!;
        this.belongedGroup = group.string_id!;
        this.belongedGroupName = group.nickname!;
    }

    // 返回集团列表时清除选中的值
    clearGroupData() {
        this.belongedGroupId = '';
        this.belongedGroup = '';
        this.belongedGroupName = '';
    }


    loadTable() {
        this.isTableLoading = true;
    }

    init(group?: Group) {
        if (group) {
            this.belongedGroup = group.string_id!;
            this.belongedGroupId = group._id!;
            this.belongedGroupName = group.nickname!;
        }
    }

    // 加载完毕
    loadedTable() {
        this.isTableLoading = false;
    }

    async getStaffsData() {
        this.loadTable();
        if (this.belongedGroup === '') {
            return
        }

        if (this.belonged === Belonged.none) {
            this.staffs = [];
            return
        }

        const params = {
            belonged_group: this.belongedGroup,
            pagination_per_page: this.rowsPerPage,
            pagination_page: this.pageIndex,
            belonged: this.belonged
        }


        const data = await apiManage.get_staff_group_belonged_group_responsible(params)
        if ('error' in data) {
            // error
        } else {
            const { dbResults } = data[0];
            this.updateStaffs(dbResults);

        }
        this.loadedTable();
    }

    updateStaffs(value: Staff[]) {
        this.staffs = value;
    }

    async save() {

    }

    async deleteStaff(row: Staff) {
        const _id = row?._id ?? '';
        const res = await apiManage.delete_staff_id(_id);
        if ('error' in res) {
            GlobalNotification.error(i18n.t('general_message_text_delete_failed'));
            return
        } else {
            GlobalNotification.success(i18n.t('allergen_page_msg_delete_succeed'));
            this.getStaffsData();
        }
    }

    async deleteStaffs(rows: Staff[]) {
        const ids = rows.map(row => row._id);
        const results = await Promise.all(
            ids.map(async (id) => await apiManage.delete_staff_id(id!))
        );
        const isSuc = results.every(e => e.error === undefined);
        if (isSuc) {
            GlobalNotification.success(i18n.t('allergen_page_msg_delete_succeed'));
            this.getStaffsData();
        } else {
            GlobalNotification.error(i18n.t('general_message_text_delete_failed'));
        }
    }

    setDiglog(value: CommonDialog) {
        this.dialog = value;
    }

}
